import React, { useRef, useCallback } from "react";
import { useClickOutsideEffect } from "utility/useClickOutside";
import { useMaxHeightTransition } from "utility/useMaxHeightTransition";

export type Option = { id: string; display: string; val?: any };

interface Props {
  className?: string;
  options: Option[];
  selectedID?: string;
  selectedDisplay: string;
  placeholder?: string;
  flipped?: boolean;
  onSelect: (selected: Option) => void;
  onAddNew?: () => void;
  arrowRightAlign?: true;
}

const InlineDropdown: React.FC<Props> = ({
  className,
  options,
  selectedDisplay,
  onSelect,
  flipped,
  onAddNew,
  arrowRightAlign,
}) => {
  const ref = useRef<HTMLDivElement>(null);
  const { open, setOpen, style } = useMaxHeightTransition("0", "240px");
  const handleClickOutside = useCallback(() => {
    setOpen(false);
  }, [setOpen]);
  useClickOutsideEffect(ref, handleClickOutside);

  return (
    <div className={`relative`} ref={ref}>
      <div
        className={`${
          className ? className : ""
        } flex items-center cursor-pointer`}
        onClick={() => setOpen(!open)}
      >
        <svg
          className={`fill-current h-4 w-4 no-print ${
            arrowRightAlign && "order-2"
          }`}
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
          style={{
            transform: open ? "rotate(180deg)" : "rotate(0deg)",
            transition: "transform 0.2s ease",
          }}
        >
          <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
        </svg>
        <span className="flex-grow truncate ml-1">{selectedDisplay}</span>
      </div>

      {open && (
        <div
          className={`rounded border border-gray-200 shadow-lg overflow-hidden overflow-y-auto absolute w-32 left-1/2 -ml-16 overflow-auto z-10 bg-white
            ${flipped ? "bottom-0 mb-6" : "top-0 mt-6"}
          `}
          style={style}
        >
          {options.length > 0 ? (
            options.map((option) => (
              <div
                className={`py-2 px-4 cursor-pointer hover:bg-gray-100`}
                key={option.id}
                onClick={() => {
                  onSelect(option);
                  // close();
                  setOpen(false);
                }}
              >
                {option.display}
              </div>
            ))
          ) : (
            <div className={`py-2 px-4`}>no options...</div>
          )}
          {onAddNew && (
            <button
              onClick={() => {
                onAddNew();
                setOpen(false);
              }}
              className={`py-2 w-full hover:bg-gray-100 focus:outline-none border-t border-gray-200`}
            >
              Add new
            </button>
          )}
        </div>
      )}
    </div>
  );
};

export default InlineDropdown;
